module.exports = __webpack_public_path__ + "img/off-icon.3666963.png";